module.exports = __webpack_public_path__ + "media/images/logos/app-store-1ea22860e6a7108063c018c24a47fcb0.png";